<template>
  <div :class="`container-root ${isSubmitting ? 'unclickable' : ''}`">
    <Breadcrumb :items.sync="breadcrumb"></Breadcrumb>
    <div class="loader" v-if="isLoading"></div>
    <div v-else>
      <div v-if="breadcrumb.length === 1">
        <div class="header-group">
          <h2 style="margin: 0px; font-weight: bold">PENDING REQUESTS</h2>
          <button class="button dark-blue" @click="showArchive">ARCHIVE</button>
        </div>
        <div style="margin-top: 25px">
          <Table
            :title="'Staff'"
            :model="list.table"
            :isLoading="list.isLoading"
            :selectedId.sync="selectedId"
            :filterIndex="3"
            :actions="list.actions"
            @onAction="onAction"
          ></Table>
        </div>
      </div>
      <div v-else>
        <Table
          :title="'Archive'"
          :model="archive.table"
          :isLoading="archive.isLoading"
          :selectedId.sync="selectedId"
          :actions="archive.actions"
          @onAction="onArchiveAction"
        ></Table>
      </div>
    </div>
    <Modal
      :isShowing.sync="reason.isShowing"
      :title="reason.title"
      :size="'width:330px;height:150px;'"
    >
      <div>{{ reason.text || 'No Reason' }}</div>
      <div class="red-col" v-if="!reason.mcUrl">No Supporting Doc uploaded</div>
      <a :href="reason.mcUrl" target="_blank" v-else>Supporting Doc</a>
    </Modal>
    <Notif v-if="notif" :data.sync="notif"></Notif>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { utils, http } from '../digilib_web/core/digitify';
import Breadcrumb from '../digilib_web/vue/breadcrumb';
import Table from '../digilib_web/vue/table';
import Modal from '../digilib_web/vue/modal';
import Notif from '../digilib_web/vue/notif';

const ACTIONS = {
  VIEW_REASON: 'View Reason',
  ACCEPT: 'Accept',
  REJECT: 'Reject',
  DELETE: 'Delete'
};

export default {
  props: {
    profile: Object
  },
  methods: {
    reload() {
      // reset table list
      let year = dayjs().year();
      this.list.isLoading = true;
      let endpoint = `employees/timeoffs/annually/${year}?where=is_approved,is,null`;
      let isPrincipal = this.profile.job_category === 'Principal';
      if (isPrincipal) {
        endpoint += `|department,=,${this.profile.department}`;
      }
      // reload
      http.get(endpoint).then(json => {
        this.list.isLoading = false;
        this.list.requests = json.data;
        // generate the table data
        this.list.table = utils.toTable(this.list.requests, {
          employee_name: { title: 'name' },
          dates: { title: 'date requested', type: 'daterange' },
          days_count: { title: 'no. of days' },
          type: { title: 'type' }
        });
      });
    },
    onAction(action, itemId) {
      let request = this.list.requests.find(x => x.id === itemId);
      switch (action) {
        case ACTIONS.VIEW_REASON:
          this.reason = {
            isShowing: true,
            text: request.reason,
            mcUrl: request.mc_url
          };
          break;
        case ACTIONS.ACCEPT:
          this.approveRequest(request.id, true);
          break;
        case ACTIONS.REJECT:
          this.approveRequest(request.id, false);
          break;
        case ACTIONS.DELETE:
          this.deleteRequest(request.id);
          break;
        default:
          break;
      }
    },
    onArchiveAction(action, itemId) {
      let request = this.archive.data.find(x => x.id === itemId);
      switch (action) {
        case ACTIONS.VIEW_REASON:
          this.reason = {
            isShowing: true,
            text: request.reason,
            mcUrl: request.mc_url
          };
          break;
        default:
          break;
      }
    },
    deleteRequest(id) {
      if (confirm(`Are you sure you want to delete this request ?`)) {
        console.log(id);
        let endpoint = `employees/timeoffs/${id}`;
        this.isSubmitting = true;
        http.del(endpoint).then(json => {
          this.isSubmitting = false;
          this.notif = utils.notif('Request Deleted!', json);
          if (json.success) {
            this.reload();
          }
        });
      }
    },
    approveRequest(id, isApproved) {
      if (
        confirm(
          `Are you sure you want to ${isApproved ? 'approve' : 'reject'} ?`
        )
      ) {
        let endpoint = `employees/timeoffs/${id}`;
        let payload = { is_approved: isApproved, approved_by: this.profile.id };
        this.isSubmitting = true;
        http.put(endpoint, payload).then(json => {
          this.isSubmitting = false;
          this.notif = utils.notif('Request Updated!', json);
          if (json.success) {
            this.reload();
          }
        });
      }
    },
    showArchive() {
      this.breadcrumb.push({ text: 'Archive' });
      this.archive.isLoading = true;
      let year = dayjs().year();
      let endpoint = `employees/timeoffs/annually/${year}?where=is_approved,isnot,null`;
      http.get(endpoint).then(json => {
        this.archive.isLoading = false;
        this.archive.data = json.data;
        // generate the table data
        this.archive.table = utils.toTable(this.archive.data, {
          employee_name: { title: 'name' },
          dates: { title: 'date requested', type: 'daterange' },
          days_count: { title: 'no. of days' },
          type: { title: 'type' },
          is_approved: { title: 'approved', type: 'bool' }
        });
      });
    }
  },
  mounted() {
    this.reload();
  },
  data() {
    return {
      selectedId: -1,
      isLoading: false,
      isSubmitting: false,
      notif: null,
      list: {
        isLoading: false,
        table: {},
        requests: [],
        actions: [
          ACTIONS.VIEW_REASON,
          ACTIONS.REJECT,
          ACTIONS.ACCEPT,
          ACTIONS.DELETE
        ]
      },
      archive: {
        isLoading: false,
        table: {},
        data: [],
        actions: [ACTIONS.VIEW_REASON, ACTIONS.DELETE]
      },
      reason: {
        isShowing: false,
        title: 'Reason',
        mcUrl: null
      },
      breadcrumb: [{ icon: 'fa fa-home', text: 'Pending Requests' }]
    };
  },
  components: {
    Table,
    Modal,
    Breadcrumb,
    Notif
  }
};
</script>

<style scoped>
.header-group {
  display: flex;
  justify-content: space-between;
}
</style>
